<template>
  <div v-show="visible" class="Loading" :class="[customClass, { 'is-fullscreen': fullscreen }, loadingClass]">
    <div v-show="title" class="Loading__title" />

    <div
      v-show="bar"
      class="Loading__bar"
      :class="{
        'Loading__bar--search': search && !sort,
        'Loading__bar--sort': sort && !search,
        'Loading__bar--sort-search': sort && search,
      }"
    />
    <div v-if="loadingClass === 'Loading--Business'" class="Loading__stats" />
    <div v-show="tabs" class="Loading__tabs" />
    <div v-show="numberItems !== 0" class="Loading__body" :style="cssVars">
      <span v-for="n in numberItems" :key="'cp' + n" class="Loading__item" />
      <!-- <div class="el-loading-spinner">
        <svg v-if="!spinner" class="circular center" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" />
        </svg>
        <i v-else :class="spinner"></i>
        <p v-if="text" class="el-loading-text">{{ text }}</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: 'grid',
      title: false,
      bar: false,
      tabs: false,
      search: false,
      sort: false,
      fullscreen: true,
      visible: false,
      modifier: '',
      customClass: '',
      numberItems: 0,
    }
  },

  computed: {
    cssVars() {
      return {
        '--numer-items': this.numberItems,
      }
    },
    loadingClass() {
      return 'Loading--' + this.type
    },
  },

  methods: {
    handleAfterLeave() {
      this.$emit('after-leave')
    },
    setNumber(number) {
      if (this.numberItems !== number) this.numberItems = number
    },
    update(prop, val) {
      if (this[prop] !== val) {
        this[prop] = val
      }
    },
  },
}
</script>

<style lang="scss">
$background: #f2f4f7;

.Loading {
  z-index: 1998;
  position: absolute;
  margin: 0;
  top: 0;
  right: 0;
  bottom: -30px;
  left: 0;
  border-left: 15px solid $background;
  border-right: 15px solid $background;
  background: $background;

  background: linear-gradient(to right, #fff 5%, #eee 15%, #fafafa 20%);
  background-size: 2000px 2000px;

  animation-duration: 0.6s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeload;
  animation-timing-function: linear;

  @keyframes placeload {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }

  .Creative & {
    margin-top: 153px;
  }

  .Creative--child & {
    margin-top: 0px;
    bottom: 0px;
  }

  .Profile & {
    border-left: 0;
    border-right: 0;
  }

  // .Tracking & {
  //   max-height: 220px;
  //   border-left: 0;
  //   border-right: 0;
  // }

  .Tracking-tab & {
    max-height: 100%;
    border-left: 0;
    border-right: 0;
  }
  .Loading__tabsanalytics & {
    height: calc(100vh);
    border-left: 0;
    border-right: 0;
  }

  &__title {
    width: 100%;
    border-top: 30px solid $background;
    border-bottom: 25px solid $background;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.09);

    &::after {
      content: ' ';
      display: block;
      width: 69%;
      height: 27px;
      float: right;
      background: $background;
    }
  }

  &__tabs {
    width: 100%;
    overflow: hidden;
    border-bottom: 25px solid $background;
    border-top: 0px solid $background;
    background: rgba(0, 0, 0, 0.08);
    &::after {
      content: ' ';
      display: block;
      width: 69%;
      height: 38px;
      float: right;
      background: $background;
    }
    &::before {
      content: ' ';
      display: block;
      height: 40px;
      float: right;
      background: $background;
    }

    .Loading--profile & {
      &::before {
        height: 37px;
      }
      &::after {
        height: 35px;
      }
    }
  }
  &__bar {
    width: 100%;
    overflow: hidden;
    border-bottom: 40px solid $background;
    background: rgba(0, 0, 0, 0.08);

    .Loading--profile & {
      border-bottom: 15px solid $background;
    }
    &::after {
      content: ' ';
      display: block;
      width: 39%;
      height: 40px;
      float: right;
      background: $background;
    }

    &--search {
      &::after {
        width: calc(39% * 0.39);
        margin-right: calc(39% * 0.61);
      }

      .Profile & {
        &::after {
          width: calc(69% * 0.31);
          margin-right: calc(69% * 0.69);
        }
        border-bottom: 20px solid $background;
      }
    }

    &--sort::after {
      width: 79%;
      .Tracking & {
        float: left;
      }
    }

    &--sort-search::after {
      width: calc(100% * 0.61);
      margin-right: calc(69% * 0.31);
    }
  }

  &__body {
    width: 100%;
    height: calc(100% - 152px);

    @at-root .MyAccount & {
      top: 52px;
      height: calc(100% - 52px);
    }
  }

  &__item {
    display: block;
    float: left;
    border-bottom: 2rem solid $background;
    box-sizing: content-box;
  }

  &--grid {
    .Loading__item {
      width: calc(100% / 3 - 20px);
      height: 218px;
      &:nth-child(3n + 2) {
        border-left: 30px solid $background;
        border-right: 30px solid $background;
      }
    }
  }

  &--light {
    .Loading__title {
      border-color: #fff;

      &::after {
        background: #fff;
      }
    }

    .Loading__item {
      width: 100%;
      height: 40px;
      border-bottom: 3rem solid #fff;

      &:nth-child(3n + 2) {
        border-left: 0;
        border-right: 0;
      }
    }
  }

  &--long-rectangle {
    .Loading__item {
      width: calc(100%);
      height: 57px;
      border-bottom: 2rem solid $background;
      &:nth-child(1) {
        height: 14px;
      }
    }
  }

  &--square-boxes {
    .Loading__item {
      width: calc(100% / 4 - 30px);
      height: 300px;

      &:nth-child(4n + 2) {
        border-left: 30px solid $background;
        border-right: 30px solid $background;
      }

      &:nth-child(4n + 3) {
        border-right: 30px solid $background;
      }
    }
  }

  &--medias {
    .Loading__item {
      width: calc(100% / 4 - 30px);
      height: 630px;

      &:nth-child(4n + 2) {
        border-left: 30px solid $background;
        border-right: 30px solid $background;
      }

      &:nth-child(4n + 3) {
        border-right: 30px solid $background;
      }
    }
  }

  &--stories {
    .Loading__item {
      width: calc(calc(100% / var(--numer-items)) - 25px);
      height: 630px;
      border-left: 30px solid $background;

      &:first-child {
        border-left: 0px;
      }
    }
  }

  &--single_page {
    .Loading__item {
      border-bottom: 3rem solid $background;

      &:nth-child(1) {
        width: calc(100% / 2 - 30px);
        height: 457px;
        border-right: 30px solid $background;
      }
      &:nth-child(2) {
        width: calc(100% / 2 - 30px);
        height: 457px;
      }

      &:nth-child(3) {
        width: 100%;
        height: 354px;
      }
    }
  }

  &--analytics {
    .Loading__item {
      border-bottom: 3rem solid $background;

      &:nth-child(1) {
        width: 100%;
        height: 439px;
      }
      &:nth-child(2) {
        width: calc(100% / 2 - 30px);
        height: 457px;
        border-right: 30px solid $background;
      }
      &:nth-child(3) {
        width: calc(100% / 2 - 30px);
        height: 457px;
      }
    }
  }

  &--product {
    .Loading__item {
      width: calc(100% / 4 - 20px);
      height: 125px;

      &:nth-child(4n + 2) {
        border-left: 20px solid $background;
        border-right: 20px solid $background;
      }

      &:nth-child(4n + 3) {
        border-right: 20px solid $background;
      }

      &:nth-child(4n + 4) {
        border-right: 20px solid $background;
      }
    }
  }

  &--tabs {
    height: 125px;
    .Loading__item {
      &:nth-child(1) {
        width: 310px;
        height: 40px;
      }

      &:nth-child(2) {
        width: calc(100% - 310px);
        height: 2px;
        margin-bottom: 38px;
      }
    }
  }

  // &--tabsanalytics {
  //   height: 205px;
  //   .Loading__item {
  //     &:nth-child(1) {
  //       width: 310px;
  //       height: 40px;
  //     }

  //     &:nth-child(2) {
  //       width: calc(100% - 310px);
  //       height: 2px;
  //       margin-bottom: 38px;
  //     }
  //   }
  // }

  &--videos-creative {
    //TODO: Check extra pixels
    .Loading__item {
      width: calc(100% / 6 - 30px);
      height: 484px;

      &:nth-child(6n + 2) {
        border-left: 36px solid $background;
        border-right: 36px solid $background;
      }

      &:nth-child(6n + 4) {
        border-left: 36px solid $background;
        border-right: 36px solid $background;
      }

      &:nth-child(6n + 5) {
        border-right: 36px solid $background;
      }
    }
  }

  &--videos-creative-v2 {
    //TODO: Check extra pixels
    .Loading__item {
      width: calc(100% / 4 - 30px);
      height: 484px;

      &:nth-child(4n + 2) {
        border-left: 36px solid $background;
        border-right: 36px solid $background;
      }

      &:nth-child(4n + 3) {
        border-right: 36px solid $background;
      }
    }
  }

  &--profile {
    max-height: 300px;
    .Loading__title {
      width: 100%;
      border-top: 30px solid $background;
      border-bottom: 25px solid $background;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.09);

      &::after {
        content: ' ';
        display: block;
        width: 69%;
        height: 130px;
        float: right;
        background: $background;
      }
    }
  }

  &--competitor {
    .Loading__item {
      width: calc(100% / 3 - 20px);
      height: 267px;

      &:nth-child(3n + 2) {
        border-left: 30px solid $background;
        border-right: 30px solid $background;
      }
    }
  }

  &--creative-edit {
    z-index: 101;
    margin-top: 20px;
    height: 730px;
    .Loading__item {
      border-top: 20px solid $background;
      width: calc((100% - 416px) / 4 - 30px);
      height: 503px;
      border-bottom: 150px solid $background;

      &:nth-child(2) {
        border-left: 30px solid $background;
        border-right: 30px solid $background;
      }
      &:nth-child(4) {
        border-left: 30px solid $background;
        border-right: 30px solid $background;
      }

      &:nth-child(5) {
        width: 416px;
        height: 626px;
      }
    }
  }
  &--Business {
    .Loading__title {
      border-top: 0px solid #f3f3f7;
    }

    .Loading__title::after {
      content: ' ';
      display: block;
      width: 60%;
      height: 27px;
      background: #f3f3f7;
      margin: 0 auto;
      float: unset;
    }

    .Loading__bar::after {
      content: ' ';
      display: block;
      width: 39%;
      height: 115px;
      float: right;
      background: #f3f3f7;
    }
    .Loading__stats {
      width: 100%;
      overflow: hidden;
      border-bottom: 30px solid #f3f3f7;
      background: rgba(0, 0, 0, 0.08);
    }
    .Loading__stats::after {
      content: ' ';
      display: block;
      width: 66%;
      height: 50px;
      float: right;
      background: #f3f3f7;
    }
  }
}
</style>
